import Button from '@mui/material/Button';
import { downloadExcelEvent } from '../../../_events/products/download_report.event';
import { Spin, message } from 'antd';
import { useDownloadExcelproducts } from '../../../hooks/products/useDownloadExcelProducts.hook';

export default function ExcelButtonDownload(){

    const hookExcel = useDownloadExcelproducts();
    
    return(
        hookExcel.loading ?
        <Spin />
        :
        <Button style={{ margin: '0 10px' }} variant="contained" onClick={hookExcel.downloadExcel}>
            Excel ODOO
        </Button>
        
    );
}